var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect, _rect2, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStart1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 275.289,
    height: 330.414,
    viewBox: "0 0 275.289 330.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-19",
    transform: "translate(0.664 0.665)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6177",
    "data-name": "Path 6177",
    d: "M1222.565,351.61c-1-.21-9.16,37.16-8.09,51.69s8.09,65.05,8.09,65.05h33.64l6.07-71.49-1.15,71.49h45.21s10.47-49.13,8.6-64-11.81-54-11.81-54Z",
    transform: "translate(-1089.677 -138.6)",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6178",
    "data-name": "Path 6178",
    d: "M1267.775,360.22a7.607,7.607,0,0,0-.07,1.39v3.81c.07,3.22.28,7.66.69,12.55s1,9.3,1.43,12.48c.23,1.59.44,2.88.6,3.76a8.227,8.227,0,0,0,.3,1.37,6.635,6.635,0,0,0-.1-1.4c-.11-1-.26-2.26-.44-3.78-.37-3.19-.86-7.6-1.27-12.48s-.68-9.31-.84-12.51c-.09-1.53-.15-2.81-.21-3.8A6.67,6.67,0,0,0,1267.775,360.22Z",
    transform: "translate(-1098.567 -138.6)",
    fill: "#455a64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6179",
    "data-name": "Path 6179",
    d: "M1276.907,363.24a1.473,1.473,0,0,0-.75,0,3.058,3.058,0,0,0-1.75,1,3.267,3.267,0,0,0-.66,1.29,2.878,2.878,0,0,0,.12,1.68,3.3,3.3,0,0,0,3,2.1,3.251,3.251,0,0,0,2.93-2.23,2.857,2.857,0,0,0,.06-1.68,2.889,2.889,0,0,0-.74-1.25,2.71,2.71,0,0,0-1.85-.86,1.13,1.13,0,0,0-.73.15h.71a2.658,2.658,0,0,1,1.6.91,2.44,2.44,0,0,1,.5,2.52,2.82,2.82,0,0,1-2.49,1.87,2.861,2.861,0,0,1-2.56-1.76,2.568,2.568,0,0,1,.38-2.56,3.134,3.134,0,0,1,1.51-1.09A3.016,3.016,0,0,0,1276.907,363.24Z",
    transform: "translate(-1113.769 -138.6)",
    fill: "#455a64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6180",
    "data-name": "Path 6180",
    d: "M1292.352,369.51a2.983,2.983,0,0,0,.88.33,13.509,13.509,0,0,0,2.53.47,15.9,15.9,0,0,0,14.69-7,13.569,13.569,0,0,0,1.23-2.21,2.833,2.833,0,0,0,.3-.9c-.09,0-.58,1.21-1.84,2.93a16.5,16.5,0,0,1-14.36,6.81C1293.682,369.83,1292.372,369.41,1292.352,369.51Z",
    transform: "translate(-1164.474 -138.6)",
    fill: "#455a64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6181",
    "data-name": "Path 6181",
    d: "M1211.447,190.31c2.55,9.28,6.41,16.73,10.17,20.46s7.79,8.1,7.65,13.4c-.05,2.08-.74,4.29.17,6.16,1.18,2.43,4.32,3,6.68,4.28a11.2,11.2,0,0,1,5.29,10.1,16.2,16.2,0,0,1-5,10.61c-2.93,2.95-7.57,5-11.21,3-2.19-1.22-3.44-3.59-4.55-5.84q-8.6-17.49-15.56-35.72",
    transform: "translate(-1006.649 -138.6)",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6182",
    "data-name": "Path 6182",
    d: "M1312.5,150.57a23.92,23.92,0,0,0-41.68,16.26c.07,6.21,2.5,12.73,0,18.43-1.73,4-5.75,7.09-6.3,11.46-.65,5.06,3.68,9.65,3.46,14.74-.15,3.33-2.24,6.27-4.64,8.57s-5.19,4.22-7.39,6.71c-6.11,6.95-6.5,17.93-1.88,25.94s13.55,13.05,22.74,14.14,18.56-1.44,26.73-5.82c5.3-2.87,10.28-6.67,13.43-11.81s4.23-11.8,1.74-17.29",
    transform: "translate(-1131.159 -138.6)",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6183",
    "data-name": "Path 6183",
    d: "M1256.4,228s-20.74,6.13-22.76,9.41-8.54,41.81-8.54,41.81l12.72,45.41s-10.53,16.95-11,25.52c23.54,15.19,50.1,10.94,77.91-1.23l2-44.37,2.64-70.88-17.12-6Z",
    transform: "translate(-1094.614 -138.6)",
    fill: "#e0e0e0",
    stroke: "#263238",
    strokeWidth: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6184",
    "data-name": "Path 6184",
    d: "M1226.492,333.77a4.383,4.383,0,0,0,.76,0l2.18-.15,8-.64,26.39-2.3,26.39-2.46,8-.8,2.17-.25a3.9,3.9,0,0,0,.75-.12,4.022,4.022,0,0,0-.76,0l-2.18.14-8,.64-26.4,2.31-26.39,2.45-8,.81-2.17.24A5.277,5.277,0,0,0,1226.492,333.77Z",
    transform: "translate(-1087.764 -138.6)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6185",
    "data-name": "Path 6185",
    d: "M1236.092,283.79c0,.14,9.11.26,20.35.26s20.35-.12,20.35-.26-9.11-.26-20.35-.26S1236.092,283.64,1236.092,283.79Z",
    transform: "translate(-1073.024 -138.6)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6186",
    "data-name": "Path 6186",
    d: "M1263.092,253.34a9.247,9.247,0,0,0,1.61.16l4.41.25c3.73.21,8.87.51,14.54.95s10.8.91,14.51,1.28l4.4.42a9.335,9.335,0,0,0,1.62.09,10.461,10.461,0,0,0-1.6-.29c-1-.16-2.53-.36-4.38-.59-3.7-.46-8.83-1-14.51-1.43s-10.83-.69-14.56-.8c-1.87,0-3.38-.08-4.42-.08A10.31,10.31,0,0,0,1263.092,253.34Z",
    transform: "translate(-1127.414 -138.6)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6187",
    "data-name": "Path 6187",
    d: "M1353.912,237.44l-20.82,56.47-14-27.82-18.26,3.74,10.51,43.85a18.6,18.6,0,0,0,14.75,15.64h0a18.6,18.6,0,0,0,17.49-5.69l6.51-7.17Z",
    transform: "translate(-1214.884 -138.6)",
    fill: "#e0e0e0",
    stroke: "#263238",
    strokeWidth: 1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6188",
    "data-name": "Path 6188",
    d: "M1321.88,329.59a6.849,6.849,0,0,0,.15-1.42c.07-.91.13-2.23.19-3.87.11-3.27.16-7.79,0-12.79s-.46-9.51-.76-12.76c-.15-1.63-.29-2.95-.41-3.86a8.6,8.6,0,0,0-.23-1.4,6.363,6.363,0,0,0,0,1.42c.06,1,.14,2.31.24,3.86.21,3.27.46,7.77.61,12.76s.16,9.5.14,12.76v3.88A8.33,8.33,0,0,0,1321.88,329.59Z",
    transform: "translate(-1203.242 -138.6)",
    fill: "#25292b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6189",
    "data-name": "Path 6189",
    d: "M1325.442,295.13c.05.14,5.17-1.68,11.43-4.06s11.3-4.42,11.25-4.55-5.17,1.68-11.43,4.06S1325.392,295,1325.442,295.13Z",
    transform: "translate(-1233.704 -138.6)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6191",
    "data-name": "Path 6191",
    d: "M1311.382,184.78l70.88,30.71-.35,20.54,8.02,8.4-27.08,24.2-7.91-8.85-21.07-2.95Z",
    transform: "translate(-1261.455 -138.6)",
    fill: "#fafafa"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M0,2.035,2.141,3.652,6.173,7.789,5.522,12.26s-4.78,1.5-4.9,2.23.589,3.189,1.329,3.31S7.7,16.05,7.7,16.05s-5.94,4.7-5.771,5.45.8,2.69,2,2.9S14.7,20.1,14.7,20.1l1.551-3.55,1.359,5.67S9.1,24.61,11.2,28.48l9.7-3.87,2.08-7.82L18.313,5.16,10.016,0Z",
    transform: "translate(99.91 129.93) rotate(180)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6192",
    "data-name": "Path 6192",
    d: "M1311.022,184.78c.62,2,9.17,29.71,22.26,72.12v.15h.15l21.07,3-.15-.08,7.95,8.83.17.2.19-.18,13.83-12.35,13.25-11.85.2-.18-.18-.19-8-8.4.07.18c.11-7.11.22-14,.33-20.54v-.16l-.15-.06-71-30.49,70.79,30.93-.14-.23c-.12,6.57-.24,13.44-.36,20.54v.11l.07.07,8,8.41v-.37l-13.26,11.84-13.81,12.36h.37l-7.92-8.84-.06-.07h-.09l-21.08-2.93.2.16C1320.382,214.43,1311.662,186.79,1311.022,184.78Z",
    transform: "translate(-1261.094 -138.6)",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6193",
    "data-name": "Path 6193",
    d: "M1344.59,235.09a11.12,11.12,0,1,0,.881-15.7h0A11.12,11.12,0,0,0,1344.59,235.09Z",
    transform: "translate(-1265.902 -138.6)",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6194",
    "data-name": "Path 6194",
    d: "M1352.882,184.78c-.11.09,8.1,9.77,18.33,21.62s18.61,21.37,18.72,21.28-8.1-9.77-18.33-21.62S1352.992,184.69,1352.882,184.78Z",
    transform: "translate(-1302.954 -138.6)",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6195",
    "data-name": "Path 6195",
    d: "M1323.9,429.67h0a17.71,17.71,0,0,0,1.47-24.94l-133.21-150.79-26.42,23.62L1298.9,428.2A17.72,17.72,0,0,0,1323.9,429.67Z",
    transform: "translate(-1055.691 -138.6)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1217",
    "data-name": "Rectangle 1217",
    width: 14.48,
    height: 41.68,
    transform: "matrix(-0.666, -0.746, 0.746, -0.666, 107.508, 141.221)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1218",
    "data-name": "Rectangle 1218",
    width: 7.72,
    height: 7.72,
    transform: "translate(50.062 51.977) rotate(-129.96)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6196",
    "data-name": "Path 6196",
    d: "M1338.1,224.77c.26.3,22.87-18.23,50.51-41.39s49.84-42.19,49.59-42.49-22.87,18.22-50.51,41.39S1337.852,224.47,1338.1,224.77Z",
    transform: "translate(-1336.444 -138.6)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6197",
    "data-name": "Path 6197",
    d: "M1435.838,225.71a2.243,2.243,0,1,0-.007-.008Z",
    transform: "translate(-1435.3 -138.6)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6198",
    "data-name": "Path 6198",
    d: "M1336.339,142.36a2.29,2.29,0,1,0,.287-3.226l-.007.006A2.29,2.29,0,0,0,1336.339,142.36Z",
    transform: "translate(-1236.331 -138.6)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6199",
    "data-name": "Path 6199",
    d: "M1328.542,253.94l-26.42,23.62,3.56,4.03,24.13-26.21Z",
    transform: "translate(-1192.074 -138.6)",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6200",
    "data-name": "Path 6200",
    d: "M1323.292,248.87v18.9l-3.85,3.95V252.3Z",
    transform: "translate(-1202.875 -138.6)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6205",
    "data-name": "Path 6205",
    d: "M1311.162,324.22s-15.55-5.34-15.92-5.51-11-5.12-10.08-8c0,0-3-2.39-2.09-3.73l4.26,1.79s-6-3.91-5-7.42c0,0-.63-1.19,0-1.93s3.76,1.49,6.08,2.89l4.48,1.8a9.376,9.376,0,0,0,6.14.3h0a2,2,0,0,0,1.35-2.28,19.582,19.582,0,0,1,.32-10.49s1.11.39,1.87,2.79c1,3.07,4,5.44,5.18,7.46.64,1.16,1.67,3,2.42,4.38a4.8,4.8,0,0,0,2.94,2.29l-1.07,8.1Z",
    transform: "translate(-1155.304 -138.6)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6206",
    "data-name": "Path 6206",
    d: "M1312.742,309.55a1.886,1.886,0,0,1-.54-.17c-.34-.12-.83-.32-1.42-.58a32.164,32.164,0,0,1-4.44-2.42,32.688,32.688,0,0,1-4-3.07c-.48-.44-.86-.8-1.11-1.06a2.9,2.9,0,0,1-.37-.43,2.065,2.065,0,0,1,.44.35l1.16,1a43.254,43.254,0,0,0,4,3,44.745,44.745,0,0,0,4.38,2.47l1.38.65A1.993,1.993,0,0,1,1312.742,309.55Z",
    transform: "translate(-1173.744 -138.6)",
    fill: "#25292b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6207",
    "data-name": "Path 6207",
    d: "M1308.182,312.65a4.746,4.746,0,0,1-1.15-.38,19.344,19.344,0,0,1-2.59-1.32,26.31,26.31,0,0,1-2.39-1.64,4.955,4.955,0,0,1-.92-.79c0-.06,1.52,1,3.45,2.21,1,.58,1.86,1,2.53,1.37A6.758,6.758,0,0,1,1308.182,312.65Z",
    transform: "translate(-1169.454 -138.6)",
    fill: "#25292b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6208",
    "data-name": "Path 6208",
    d: "M1310,316.37a8.3,8.3,0,0,1-1.46-.56,28.2,28.2,0,0,1-3.32-1.8,30.7,30.7,0,0,1-3.06-2.21,7.718,7.718,0,0,1-1.16-1.06,11.378,11.378,0,0,1,1.27.91c.77.58,1.85,1.36,3.09,2.14a37.1,37.1,0,0,0,3.26,1.85A10.894,10.894,0,0,1,1310,316.37Z",
    transform: "translate(-1171.144 -138.6)",
    fill: "#25292b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6209",
    "data-name": "Path 6209",
    d: "M1206.036,324.22l57.72,17.36a34.461,34.461,0,0,0,20.11-34.44c-1.82-20.4-4.22-47.23-4.93-54-1.18-11.23-14.06-19.5-14.06-19.5-17.7,1.15-13.78,36.16-13.78,36.16l7.13,40.27-50.19-2Z",
    transform: "translate(-1050.178 -138.6)",
    fill: "#e0e0e0",
    stroke: "#25292b",
    strokeWidth: 1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6210",
    "data-name": "Path 6210",
    d: "M1238.936,310.1a10.312,10.312,0,0,0-.07-1.61c-.07-1-.24-2.52-.45-4.37-.45-3.67-1.23-8.73-2.27-14.29s-2.07-10.57-2.89-14.18c-.4-1.81-.75-3.27-1-4.27a8.113,8.113,0,0,0-.45-1.55,10.974,10.974,0,0,0,.25,1.59c.22,1.11.5,2.56.84,4.3.72,3.63,1.71,8.65,2.74,14.2s1.87,10.6,2.42,14.25c.24,1.77.45,3.23.61,4.34A9.02,9.02,0,0,0,1238.936,310.1Z",
    transform: "translate(-1030.888 -138.6)",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6211",
    "data-name": "Path 6211",
    d: "M1228.052,308.09a1.862,1.862,0,0,0,.54.08l1.57.14c1.37.1,3.34.22,5.78.35,4.88.25,11.63.48,19.08.7l19.08.54,5.78.19h1.57a1.81,1.81,0,0,0,.55,0,1.864,1.864,0,0,0-.54-.08l-1.57-.14c-1.37-.1-3.34-.23-5.78-.35-4.88-.25-11.63-.48-19.08-.7l-19.07-.54-5.79-.19h-1.57A1.812,1.812,0,0,0,1228.052,308.09Z",
    transform: "translate(-1070.194 -138.6)",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6212",
    "data-name": "Path 6212",
    d: "M1207.132,294.83a4,4,0,0,0,1.06,0l2.88-.22c2.43-.18,5.78-.42,9.49-.57s7.06-.21,9.5-.22h2.88a4.488,4.488,0,0,0,1.06-.07,3.932,3.932,0,0,0-1-.13c-.68-.06-1.67-.1-2.89-.14-2.44-.08-5.81-.09-9.53.07s-7.07.44-9.5.73c-1.21.13-2.18.27-2.86.37A4.85,4.85,0,0,0,1207.132,294.83Z",
    transform: "translate(-1001.274 -138.6)",
    fill: "#25292b"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6213",
    "data-name": "Path 6213",
    d: "M1209.752,267.05c0,.14,6.55,0,14.61-.36s14.59-.72,14.58-.87-6.54,0-14.6.35S1209.752,266.9,1209.752,267.05Z",
    transform: "translate(-1008.834 -138.6)",
    fill: "#25292b"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6214",
    "data-name": "Path 6214",
    d: "M1231.652,328.28a4.261,4.261,0,0,0-.55-.92c-.39-.58-1-1.39-1.74-2.37a60.493,60.493,0,0,0-6.6-7.09,59.157,59.157,0,0,0-7.67-5.92,28.447,28.447,0,0,0-2.51-1.51,4.027,4.027,0,0,0-1-.47c0,.07,1.26.87,3.28,2.29a72.625,72.625,0,0,1,14.18,12.94C1230.662,327.11,1231.582,328.33,1231.652,328.28Z",
    transform: "translate(-1003.374 -138.6)",
    fill: "#25292b"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6215",
    "data-name": "Path 6215",
    d: "M1249.164,333.77c.14,0,1.11-5.39,2.17-12.1s1.8-12.17,1.66-12.19-1.12,5.4-2.18,12.11S1249.014,333.75,1249.164,333.77Z",
    transform: "translate(-1062.296 -138.6)",
    fill: "#25292b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3254",
    "data-name": "Group 3254",
    transform: "translate(149.288 183.4)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6216",
    "data-name": "Path 6216",
    d: "M1287.922,341.58,1223.282,322c4.84,6.38,14.28,12.32,21.4,16s14.73,6.26,22.31,8.84c4.12,1.4,8.34,2.82,12.69,2.78s8.6-1.29,10.89-5Z",
    transform: "translate(-1223.282 -322)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6217",
    "data-name": "Path 6217",
    d: "M1225.759,175.41a6.83,6.83,0,0,1,2.38-8.13,7.341,7.341,0,0,1,8.56.43,8,8,0,0,1,2.48,8.29,8.14,8.14,0,0,1-15.84-1.14",
    transform: "translate(-1022.971 -138.6)",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6218",
    "data-name": "Path 6218",
    d: "M1292.786,158.53v4.72l1,70.71c.12,8.21-6.85,14.85-15.64,14.9h0c-8.87.06-16.27-6.61-16.53-14.9-.26-8.7-.7-17.86-.7-17.86s-11.26-1.55-14-16.11c-1.36-7.24-1.32-19.18-1-29a15.449,15.449,0,0,1,15.974-14.907c.222.007.444.02.666.037Z",
    transform: "translate(-1099.658 -138.6)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6219",
    "data-name": "Path 6219",
    d: "M1284.832,179.56a1.87,1.87,0,0,0,1.86,1.84,1.8,1.8,0,0,0,1.888-1.707l0-.043a1.89,1.89,0,0,0-1.86-1.84,1.791,1.791,0,0,0-1.888,1.687C1284.833,179.518,1284.832,179.539,1284.832,179.56Z",
    transform: "translate(-1133.554 -138.6)",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6220",
    "data-name": "Path 6220",
    d: "M1283.361,177.18c.24.24,1.64-.86,3.65-.91s3.53.92,3.74.67-.14-.55-.8-1a5.159,5.159,0,0,0-3-.83,5,5,0,0,0-2.9,1C1283.441,176.62,1283.251,177.07,1283.361,177.18Z",
    transform: "translate(-1134.283 -138.6)",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6221",
    "data-name": "Path 6221",
    d: "M1265.082,179.36a1.889,1.889,0,0,0,1.86,1.85,1.8,1.8,0,0,0,1.888-1.707l0-.043a1.87,1.87,0,0,0-1.86-1.84,1.8,1.8,0,0,0-1.889,1.707Z",
    transform: "translate(-1094.054 -138.6)",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6222",
    "data-name": "Path 6222",
    d: "M1263.5,177c.24.23,1.63-.86,3.65-.91s3.52.92,3.74.67-.15-.55-.81-1a5.152,5.152,0,0,0-3-.84,5,5,0,0,0-2.9,1C1263.582,176.45,1263.382,176.9,1263.5,177Z",
    transform: "translate(-1094.564 -138.6)",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6223",
    "data-name": "Path 6223",
    d: "M1282.547,192.18a12.811,12.811,0,0,0-3.29-.5c-.52,0-1-.13-1.11-.48a2.611,2.611,0,0,1,.31-1.54l1.41-4c2-5.65,3.37-10.29,3.14-10.37s-2,4.44-4,10.09c-.48,1.39-.93,2.72-1.36,4a3.064,3.064,0,0,0-.21,2,1.309,1.309,0,0,0,.87.73,3.624,3.624,0,0,0,.88.1A13.493,13.493,0,0,0,1282.547,192.18Z",
    transform: "translate(-1120.529 -138.6)",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6224",
    "data-name": "Path 6224",
    d: "M1259.132,216.1a37.151,37.151,0,0,0,19.44-5.76s-4.47,10.18-19.15,9.21Z",
    transform: "translate(-1097.844 -138.6)",
    opacity: 0.21
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6225",
    "data-name": "Path 6225",
    d: "M1270.988,197a3.638,3.638,0,0,1,3.22-1.44,3.322,3.322,0,0,1,2.33,1.17,2.11,2.11,0,0,1,.23,2.4,2.451,2.451,0,0,1-2.63.74,7.65,7.65,0,0,1-2.62-1.47,2.362,2.362,0,0,1-.6-.58.659.659,0,0,1,0-.75",
    transform: "translate(-1107.98 -138.6)",
    opacity: 0.21
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6226",
    "data-name": "Path 6226",
    d: "M1277.783,193.41c-.33,0-.27,2.18-2.1,3.79s-4.17,1.43-4.18,1.74c0,.13.53.41,1.52.41a5.523,5.523,0,0,0,3.49-1.33,4.722,4.722,0,0,0,1.62-3.17C1278.193,193.93,1277.933,193.39,1277.783,193.41Z",
    transform: "translate(-1109.785 -138.6)",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6227",
    "data-name": "Path 6227",
    d: "M1262.432,169.11c.21.54,2.22.23,4.6.45s4.31.81,4.61.31c.13-.24-.22-.75-1-1.26a8.042,8.042,0,0,0-7.02-.58C1262.752,168.41,1262.323,168.85,1262.432,169.11Z",
    transform: "translate(-1094.225 -138.6)",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6228",
    "data-name": "Path 6228",
    d: "M1283.389,171.31c.37.45,1.75-.06,3.42-.13s3.1.22,3.41-.27c.14-.23-.1-.69-.73-1.1a4.93,4.93,0,0,0-5.5.32C1283.409,170.62,1283.229,171.1,1283.389,171.31Z",
    transform: "translate(-1133.731 -138.6)",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6229",
    "data-name": "Path 6229",
    d: "M1224.312,153.89c-3.91,5.2.16,12.56,4.66,17.25s10,10.14,8.77,16.52c-1.43,7.41-11.55,12.15-10.05,19.54.55,2.69,2.68,5,2.69,7.74,0,5-6.41,7.38-8.26,12-2.54,6.32,4.43,12.62,4.54,19.43.06,3.86-2.13,7.47-2.25,11.33-.24,7.91,9.12,13.71,16.8,11.76s12.93-9.46,14.58-17.19-.87-18.62-2.11-26.44l13.3,3.09c2.48-2.37-.91-4.88-1.47-8.25-1.4-8.47-7-15.64-9.61-23.8-2.31-7.13-2.33-14.77-3.34-22.2s-3.31-15.17-9-20.08-15.5-5.5-20.09.43",
    transform: "translate(-1049.584 -138.6)",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6230",
    "data-name": "Path 6230",
    d: "M1266.562,177.92a23.228,23.228,0,0,1-5.86.18,25,25,0,0,1-12.72-5.76,53.486,53.486,0,0,1-9.29-10.71c-1-1.45-1.82-2.66-2.44-3.58a9.977,9.977,0,0,0-.94-1.28,8.808,8.808,0,0,0,.77,1.39c.52.88,1.3,2.14,2.3,3.67a49.32,49.32,0,0,0,9.27,10.91,24.429,24.429,0,0,0,13,5.72,16.086,16.086,0,0,0,4.36-.15,10.461,10.461,0,0,0,1.15-.25C1266.432,178,1266.572,177.94,1266.562,177.92Z",
    transform: "translate(-1062.014 -138.6)",
    fill: "#455a64"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6231",
    "data-name": "Path 6231",
    d: "M1235.762,179.88a7.685,7.685,0,0,0,2.13,1.49,18.334,18.334,0,0,0,6,2,18.113,18.113,0,0,0,6.29-.19,8.011,8.011,0,0,0,2.47-.81c0-.09-1,.21-2.54.45a20.529,20.529,0,0,1-12-1.76C1236.642,180.36,1235.822,179.81,1235.762,179.88Z",
    transform: "translate(-1048.554 -138.6)",
    fill: "#455a64"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6232",
    "data-name": "Path 6232",
    d: "M1292.382,170.05a8.712,8.712,0,0,0,7.81-4.63,21.5,21.5,0,0,1-3.52,3A21.029,21.029,0,0,1,1292.382,170.05Z",
    transform: "translate(-1152.714 -138.6)",
    fill: "#455a64"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6233",
    "data-name": "Path 6233",
    d: "M1294.032,175a5.188,5.188,0,0,0,5.22-1.3c-.09-.12-1.12.53-2.55.87S1294.052,174.82,1294.032,175Z",
    transform: "translate(-1153.424 -138.6)",
    fill: "#455a64"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6234",
    "data-name": "Path 6234",
    d: "M1236.745,181.1a10.7,10.7,0,0,0,.42-4.84,10.951,10.951,0,0,0-1.26-4.7c-.15.05.52,2.11.74,4.74S1236.6,181.08,1236.745,181.1Z",
    transform: "translate(-1033.297 -138.6)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6202",
    "data-name": "Path 6202",
    d: "M1348.091,258.37c-.06,0-.24-.33-.33-1a5.175,5.175,0,0,1,.29-2.45,5.261,5.261,0,0,1,1.37-2.05c.48-.42.85-.57.88-.52a11.12,11.12,0,0,0-1.78,2.74A10.985,10.985,0,0,0,1348.091,258.37Z",
    transform: "translate(-1258.163 -138.6)",
    fill: "#25292b"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6203",
    "data-name": "Path 6203",
    d: "M1342.752,256.68a21.133,21.133,0,0,0,.38-2.54,11.3,11.3,0,0,1,.49-2.82,4.305,4.305,0,0,1,.89-1.5,4.7,4.7,0,0,1,1.59-1c2.32-.84,4.41-1.52,5.94-2a12.519,12.519,0,0,1,2.5-.69,13.9,13.9,0,0,1-2.39,1c-1.49.58-3.59,1.32-5.86,2.15a4.041,4.041,0,0,0-1.42.87,3.89,3.89,0,0,0-.82,1.32,12.038,12.038,0,0,0-.56,2.7A5.258,5.258,0,0,1,1342.752,256.68Z",
    transform: "translate(-1257.434 -138.6)",
    fill: "#25292b"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6204",
    "data-name": "Path 6204",
    d: "M1356.152,254.93a4,4,0,0,1,.07-1.92c.17-1,.42-1.85.55-1.83a3.918,3.918,0,0,1-.06,1.92C1356.542,254.14,1356.272,255,1356.152,254.93Z",
    transform: "translate(-1273.064 -138.6)",
    fill: "#25292b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart1);
export default __webpack_public_path__ + "static/media/start1.9d70185e643be1b7d16ee6307d180757.svg";
export { ForwardRef as ReactComponent };